/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.22.1",
  "gitBuildTime": "2024-04-30T14:35:49.039Z",
  "gitBuildVersion": "1.22.1",
  "gitCommitId": "de7cc4e",
  "gitCommitIdFull": "de7cc4e3b30d9476145e78c3aa052f128cf4d1cc",
  "gitCommitTime": "2024-04-30T14:34:13.000Z",
  "version": "1.22.1-2024-04-30T14:34:13.000Z-(de7cc4e)"
};
